export class ErrorDialog {
  doc: Document;

  constructor(doc: Document) {
    this.doc = doc;
  }

  public overwriteTitle(title: string): ErrorDialog {
    const errorDialogTitle = this.doc.getElementById("tabBootErrTitle");
    if (errorDialogTitle) {
      errorDialogTitle.textContent = title;
    }
    return this;
  }

  public overwriteBody(body: string) {
    const errorDialogBody = this.doc.getElementById("tabBootErrBody");
    if (errorDialogBody) {
      errorDialogBody.textContent = body;
    }
    return this;
  }

  public overwriteBodyHTML(body: string) {
    const errorDialogBody = this.doc.getElementById("tabBootErrBody");
    if (errorDialogBody) {
      errorDialogBody.innerHTML = body;
    }
    return this;
  }

  private hideLoadIndicators() {
    const parent = window.parent;
    if (parent && parent.postMessage) {
      parent.postMessage("tableau.completed", "*");
    }
  }

  public show() {
    this.hideLoadIndicators();
    setTimeout(() => {
      // Allow any embedding pages to handle the vizloaderror. This execution
      // context will run to completion before that message will be dispatched
      // to the parent window.
      const errorDialog = this.doc.getElementById("tabBootErr");
      if (errorDialog) {
        errorDialog.style.display = "block";
      }
    }, 0);
  }
}
